import { NgModule } from '@angular/core';
import { AnaBizLoginStoreService } from './ana-biz-login-store.service';

@NgModule({
  providers: [AnaBizLoginStoreService],
})
export class AnaBizLoginStoreServiceModule {}
